export default __webpack_public_path__ + "static/media/logo.c949d0e8.png";